import styled, { css } from 'styled-components';

export const Content = styled.div`
  margin: 0 0 1rem;
  position: relative;
  color: #fff;
  padding-left: 8px;
  &.is-app {
    padding-left: 0;
  }
`;

export const Title = styled.div`
  margin: 0 0 5px;
`;

export const Select = styled.select`
  margin-right: 1rem;
  border-radius: 4px;
  min-width: 150px;
  cursor: pointer;
`;

export const Block = styled.div`
  display: flex;
`;
